import { render, staticRenderFns } from "./AbkRecordsList.vue?vue&type=template&id=29b49cf6&scoped=true&"
import script from "./AbkRecordsList.vue?vue&type=script&lang=js&"
export * from "./AbkRecordsList.vue?vue&type=script&lang=js&"
import style0 from "./AbkRecordsList.vue?vue&type=style&index=0&id=29b49cf6&lang=scss&scoped=true&"
import style1 from "./AbkRecordsList.vue?vue&type=style&index=1&id=29b49cf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b49cf6",
  null
  
)

export default component.exports